module.exports = __webpack_public_path__ + "public/images/about-5.77db9ef89ec50b0374add4f2fa1f53eb.png";